@if (isPending) {
  <mat-icon fontSet="mdi" fontIcon="mdi-loading" class="mdi-spin loading tooltip-icon xs"></mat-icon>
} @else {
  @if (isEditing) {
    <div class="buttons-container fx-layout-row">
      <button #cancelButton (click)="onButtonCancelClick()"
        (keydown.tab)="onButtonCancelTab($event)"
        id="cancel-edit-row-button"
        class="fx-layout-row fx-justify-center fx-align-center"
        [matTooltip]="'BUTTON.CANCEL' | translate"
        type="button"
        mat-icon-button>
        <mat-icon fontSet="mdi" fontIcon="mdi-close" aria-hidden="true" class="xs"></mat-icon>
      </button>
      <button #saveButton (click)="onButtonSaveClick()"
        (keydown.tab)="onButtonSaveTab($event)"
        id="save-edit-row-button"
        color="accent"
        type="button"
        class="fx-layout-row fx-justify-center fx-align-center"
        [matTooltip]="'BUTTON.SAVE' | translate"
        [disabled]="params.formGroup.invalid"
        mat-icon-button>
        <mat-icon fontSet="mdi" fontIcon="mdi-check" aria-hidden="true" class="xs"></mat-icon>
      </button>
    </div>
  } @else {
    <div class="buttons-container">
      <button (click)="onButtonStartClick()"
        [permission-lock]="params.editPermissions"
        id="enter-edit-row-button"
        type="button"
        class="fx-layout-row fx-justify-center fx-align-center"
        [matTooltip]="'BUTTON.EDIT' | translate"
        mat-icon-button>
        <mat-icon fontSet="mdi" fontIcon="mdi-pencil" aria-hidden="true" class="xs"></mat-icon>
      </button>
    </div>
  }
}

